// ✅ FULL UPDATED TS FILE (child-list.component.ts)
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OrganizationService } from 'src/app/@Services/account-list.service';

@Component({
  selector: 'app-child-list',
  templateUrl: './child-list.component.html',
  styleUrls: ['./child-list.component.css'],
})
export class ChildListComponent implements OnInit {
  parentOptions: string[] = ['OEM', 'Financial Institution', 'Incubator'];
  identityMap: { [key: string]: string } = {
    OEM: 'Supplier',
    'Financial Institution': 'Portfolio companies',
    Incubator: 'Incubatee',
  };
  childOptions: string[] = [];

  parentIdentity = '';
  childIdentity = '';
  groupName = '';
  companySearch = '';

  organizationList: any[] = [];
  filteredOrganizations: any[] = [];
  showSuggestions = false;

  children: {
    child_company_id: number;
    parent_identity: string;
    child_identity: string;
    group_name: string;
  }[] = [];

  orgId = '';
  orgName = '';
  currentPage = 1;
  itemsPerPage = 7;

  // ✅ Modal control
  showDeleteModal = false;
  confirmMessage = '';
  childToDelete: any = null;

  constructor(
    private orgService: OrganizationService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    const navState = history.state;
    this.children = navState?.childCompanies || [];
    this.orgName = navState?.orgName || '';
    this.orgId = navState?.orgId;

    this.orgService.getOrganizations().subscribe({
      next: (res: any) => {
        this.organizationList = res?.data || res;
        this.filteredOrganizations = this.organizationList.filter(
          (org) =>
            org.organization_name.toLowerCase() !== this.orgName.toLowerCase()
        );
      },
      error: (err: any) => {
        console.error('Failed to fetch organization list:', err);
        this.toastr.error('Failed to load organizations.', 'Error');
      },
    });
  }

  getChildName(id: number): string {
    const org = this.organizationList.find((org) => org.id === id);
    return org ? org.organization_name : 'Unknown';
  }

  onParentChange() {
    this.childIdentity = this.identityMap[this.parentIdentity] || '';
    this.childOptions = this.childIdentity ? [this.childIdentity] : [];
  }

  filterOrganizations() {
    const query = this.companySearch.toLowerCase();
    this.filteredOrganizations = query
      ? this.organizationList.filter(
          (org) =>
            org.organization_name.toLowerCase().includes(query) &&
            org.organization_name.toLowerCase() !== this.orgName.toLowerCase()
        )
      : this.organizationList.filter(
          (org) =>
            org.organization_name.toLowerCase() !== this.orgName.toLowerCase()
        );

    this.showSuggestions = true;
  }

  selectOrganization(name: string) {
    this.companySearch = name;
    this.showSuggestions = false;
  }

  hideSuggestions() {
    setTimeout(() => (this.showSuggestions = false), 200);
  }

  addChild() {
    const trimmed = this.companySearch.trim();
    const match = this.organizationList.find(
      (org) => org.organization_name === trimmed
    );

    if (
      trimmed &&
      this.parentIdentity &&
      this.childIdentity &&
      this.groupName &&
      match
    ) {
      this.children.push({
        child_company_id: match.id,
        parent_identity: this.parentIdentity,
        child_identity: this.childIdentity,
        group_name: this.groupName,
      });
      this.companySearch = '';
      this.groupName = '';

      this.toastr.success('Child organization added!', 'Success');
    } else {
      this.toastr.error(
        'Please complete all fields and select a valid company.',
        'Validation Error'
      );
    }
  }


  
removeChild(child: any) {
  this.childToDelete = child;
  this.confirmMessage = `Are you sure you want to delete '${this.getChildName(child.child_company_id)}'?`;
  this.showDeleteModal = true;
}


  confirmDelete() {
    if (this.childToDelete) {
      this.children = this.children.filter((c) => c !== this.childToDelete);
      this.toastr.info('Child removed successfully.', 'Info');
      this.childToDelete = null;
    }
    this.showDeleteModal = false;
  }

  closeModal() {
    this.showDeleteModal = false;
    this.childToDelete = null;
  }

  get paginatedChildren() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.children.slice(start, start + this.itemsPerPage);
  }

  get totalPages() {
    return Math.ceil(this.children.length / this.itemsPerPage);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  goBack() {
    const clonedChildren = this.children.map((child) => ({
      child_company_id: child.child_company_id,
      parent_identity: child.parent_identity,
      child_identity: child.child_identity,
      group_name: child.group_name,
    }));

    const navState = window.history.state;

    this.router.navigate(
      this.orgId ? [`/master/org-form/${this.orgId}`] : ['/master/org-form'],
      {
        state: {
          childCompanies: clonedChildren,
          orgName: this.orgName,
          formData: navState?.formData || {},
        },
      }
    );
  }
}
